'use strict';

var _ = require('lodash');
var StrategyMqSposDowGrp = function StrategyMqSposDowGrp(strategyHelper) {
  function getLabel(season, dowGroup) {
    return dowGroup;
  }
  function getProfileLevel() {
    return 'MQ_SPOS_DOWG';
  }
  function condition(quickFilterData, season, dowGroup) {
    return _.isArray(quickFilterData.dows) && quickFilterData.dows.indexOf(dowGroup) !== -1;
  }
  function profileMatched(quickFilterData, season, dowGroup) {
    return condition(quickFilterData, season, dowGroup);
  }
  function getFillData(quickFilterData, season, dowGroup) {
    return strategyHelper.getFillData(quickFilterData, season, dowGroup, condition);
  }
  return {
    getLabel: getLabel,
    getFillData: getFillData,
    profileMatched: profileMatched,
    getProfileLevel: getProfileLevel
  };
};
StrategyMqSposDowGrp.$inject = ['StrategyHelper'];
module.exports = StrategyMqSposDowGrp;